<template>
  <div :class="[theme.group, groupClass]">
    <component
      v-for="(block, idx) in blocks"
      :key="idx"
      :is="block.component"
      v-bind="block.props || {}"
    />
  </div>
</template>

<script setup>
import { groupBlockTheme } from './scripts/themeHelpers';


const props = defineProps({
  blocks: { type: Array, default: () => [] },
  variant: { type: String, default: 'default' },
  groupClass: { type: String, default: '' },
})

// Résolution des classes basées sur la variante
const theme = groupBlockTheme(props.variant)
</script>

<style scoped>
/* Styles génériques si nécessaire */
</style>
